import React from "react";
import { MdLocationOn } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { HiMail } from "react-icons/hi";
import { RiFacebookFill } from "react-icons/ri";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { IoPersonCircleOutline } from "react-icons/io5";
import { FaLinkedin, FaWhatsapp } from "react-icons/fa";

import "./Footer.css";
import PPLogo from "../../assets/images/P&PLogo.png";

const Footer = ({ currentLanguage = "en" }) => {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    quickLinks: {
      title: "QUICK LINKS",
      links: [
        { href: "/", text: "Home" },
        { href: "/about", text: "About Us" },
        { href: "/careers", text: "Careers" },
        // { href: "#", text: "Services" },
        // { href: "#", text: "Industries" },
        { href: "/blog", text: "Insight" },
      ],
    },
    // company: {
    //   title: "COMPANY",
    //   links: [
    //     { href: "#", text: "Our Team" },
    //     { href: "/careers", text: "Careers" },
    //     { href: "#", text: "Testimonials" },
    //     { href: "#", text: "Tax & Audit Updates" },
    //   ],
    // },
    support: {
      title: "SUPPORT PAGES",
      links: [
        // { href: "#", text: "Live Chat" },
        { href: "#", text: "Terms & Conditions" },
        { href: "#", text: "Privacy Policy" },
        { href: "#", text: "FAQ" },
      ],
    },
    contact: {
      title: "CONTACT US",
      address: "Aux 1200 Logements, Avenue Jean-Baptiste Kiendrebeogo, Ouagadougou, Burkina Faso",
      phone: "+226 70 19 20 68",
      email: "info@pestelandpartners.com",
    },
    copyright: "© 2025 Pestel & Partners. All Rights Reserved",
    bottomLinks: [
      { href: "#", text: "Privacy Policy" },
      { href: "#", text: "Terms of Service" },
      { href: "#", text: "Cookie Policy" },
    ],
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    quickLinks: {
      title: "LIENS RAPIDES",
      links: [
        { href: "/", text: "Accueil" },
        { href: "/about", text: "À Propos" },
        { href: "/careers", text: "Carrières" },
        // { href: "#", text: "Services" },
        // { href: "#", text: "Industries" },
        { href: "/blog", text: "Actualités" },
      ],
    },
    // company: {
    //   title: "ENTREPRISE",
    //   links: [
    //     { href: "#", text: "Notre Équipe" },
    //     { href: "/careers", text: "Carrières" },
    //     { href: "#", text: "Témoignages" },
    //     { href: "#", text: "Mises à Jour Fiscales et d'Audit" },
    //   ],
    // },
    support: {
      title: "PAGES D'ASSISTANCE",
      links: [
        // { href: "#", text: "Chat en Direct" },
        { href: "#", text: "Conditions Générales" },
        { href: "#", text: "Politique de Confidentialité" },
        { href: "#", text: "FAQ" },
      ],
    },
    contact: {
      title: "CONTACTEZ-NOUS",
    address: "Aux 1200 logements, avenue Jean-Baptiste Kiendrebeogo, Ouagadougou, Burkina Faso",
      phone: "+226 70 19 20 68",
      email: "info@pestelandpartners.com",
    },
    copyright: "© 2025 Pestel & Partners. Tous Droits Réservés",
    bottomLinks: [
      { href: "#", text: "Politique de Confidentialité" },
      { href: "#", text: "Conditions d'Utilisation" },
      { href: "#", text: "Politique de Cookies" },
    ],
  }; 

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;

  return (
    <footer className="footer-wrapper">
      <div className="footer-bg"></div>

      {/* LOGO WITH BORDERS */}
      <div className="row">
        <div className="col-12 mb-4">
          <div className="footer-logo-container">
            <div className="footer-logo-line"></div>
            <img src={PPLogo} alt="Pestel & Partners" className="footer-logo" />
            <div className="footer-logo-line"></div>
          </div>
        </div>
      </div>

      {/* MAIN ROW */}
      <div className="row">
        {/* QUICK LINKS */}
        <div className="mobreswidth1 mobreswidth">
          <h6 className="footerTitle">{data.quickLinks.title}</h6>
          <div className="footer-line"></div>
          <div className="footerLinkWrapper">
            {data.quickLinks.links.map((link, index) => (
              <a href={link.href} className="footerLink" key={index}>
                {link.text}
              </a>
            ))}
          </div>
        </div>

        {/* COMPANY */}
        {/* <div className="mobreswidth1 mobreswidth">
          <h6 className="footerTitle">{data.company.title}</h6>
          <div className="footer-line"></div>
          <div className="footerLinkWrapper">
            {data.company.links.map((link, index) => (
              <a href={link.href} className="footerLink" key={index}>
                {link.text}
              </a>
            ))}
          </div>
        </div> */}

        {/* SUPPORT PAGES */}
        <div className="mobreswidth2 mobreswidth">
          <h6 className="footerTitle">{data.support.title}</h6>
          <div className="footer-line"></div>
          <div className="footerLinkWrapper">
            {data.support.links.map((link, index) => (
              <a href={link.href} className="footerLink" key={index}>
                {link.text}
              </a>
            ))}
          </div>
        </div>

        {/* CONTACT US */}
        <div className="mobreswidth3 mobreswidth">
          <h6 className="footerTitle">{data.contact.title}</h6>
          <div className="footer-line"></div>
          <div className="footerContactItem">
            <MdLocationOn size={28} />
            <span>{data.contact.address}</span>
          </div>
          <div className="footerContactItem">
            <FaPhone size={13} />
            <span className="ms-1">{data.contact.phone}</span>
          </div>
          <div className="footerContactItem">
            <HiMail size={16} />
            <span>{data.contact.email}</span>
          </div>
          <div className="mt-3">
            <a
              href="https://www.facebook.com/pestelpartnersburkinafaso/"
              className="socialIcon"
              style={{ cursor: "pointer" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <RiFacebookFill />
            </a>

            <a
              href="https://www.linkedin.com/company/pestel-partners-africa/"
              className="socialIcon"
              style={{ cursor: "pointer" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>

            <a
              href="https://www.instagram.com/pestelpartners_africa/"
              className="socialIcon"
              style={{ cursor: "pointer" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://wa.me/+226 70 19 20 68"
              target="_blank"
              rel="noopener noreferrer"
              className="socialIcon"
              style={{ cursor: "pointer" }}
            >
              <FaWhatsapp />
            </a>

            <a
              href="/profile"
              className="socialIcon"
              style={{ cursor: "pointer" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoPersonCircleOutline />
            </a>
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom mt-3 pt-4">
        <p style={{ color: "white" }}>{data.copyright}</p>
        <div className="footer-bottom-links">
          {data.bottomLinks.map((link, index) => (
            <a href={link.href} className="footerLink footer-border-right" key={index}>
              {link.text}
            </a>
          ))}
        </div>
      </div>

    </footer>
  );
};

export default Footer;